import { CreateAndUpdateArgs } from "../../interfaces/DossierInterface";
import axios, { AxiosResponse } from "axios";
import { ApiEnum } from "../../constants/ApiEnum";
import { disableApiError } from "../../../app/rootReducer";
import { Dispatch } from "redux";

interface ApiDossierCreateAndUpdateData {
    data: {
        status: {
            message: object;
        };
    };
}

export const ApiDossierCreateAndUpdate = async (
    slug: string,
    dispatch: Dispatch,
    args?: CreateAndUpdateArgs,
): Promise<AxiosResponse<ApiDossierCreateAndUpdateData>> => {
    return await axios
        .post(
            ApiEnum.DOSSIER + "/create-and-update",
            {
                data: {
                    patchData: args?.data,
                    registration_link: slug,
                },
            },
            {
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },
            },
        )
        .then(function (response) {
            dispatch(disableApiError());
            return response;
        })
        .catch(function (error) {
            return error;
        });
};
